var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundingsource(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 26,
    viewBox: "0 0 37 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H30C32.2091 0 34 1.79086 34 4V12.6667C34 13.219 33.5523 13.6667 33 13.6667C32.4477 13.6667 32 13.219 32 12.6667V4C32 2.89543 31.1046 2 30 2H4C2.89543 2 2 2.89543 2 4V18C2 19.1046 2.89543 20 4 20H18.6842C19.2365 20 19.6842 20.4477 19.6842 21C19.6842 21.5523 19.2365 22 18.6842 22H4C1.79086 22 0 20.2091 0 18V4Z",
    fill: "#339DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11C20 12.6569 18.6569 14 17 14C15.3431 14 14 12.6569 14 11C14 9.34315 15.3431 8 17 8C18.6569 8 20 9.34315 20 11ZM18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11Z",
    fill: "#339DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C13 11.5523 12.5523 12 12 12H10C9.44772 12 9 11.5523 9 11C9 10.4477 9.44772 10 10 10H12C12.5523 10 13 10.4477 13 11Z",
    fill: "#339DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24.5523 12 25 11.5523 25 11C25 10.4477 24.5523 10 24 10H23C22.4477 10 22 10.4477 22 11C22 11.5523 22.4477 12 23 12H24Z",
    fill: "#339DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C5.89543 5 5 5.89543 5 7V15C5 16.1046 5.89543 17 7 17H26C27.1046 17 28 16.1046 28 15V7C28 5.89543 27.1046 5 26 5H7ZM26 7H7L7 15H26V7Z",
    fill: "#339DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2293 20.4889C24.2293 19.9366 24.677 19.4889 25.2293 19.4889H32.3708L30.3518 17.4699C29.9613 17.0793 29.9613 16.4462 30.3518 16.0556C30.7423 15.6651 31.3755 15.6651 31.766 16.0556L35.8847 20.1743C36.2752 20.5648 36.2752 21.198 35.8847 21.5885L31.766 25.7071C31.3755 26.0976 30.7423 26.0976 30.3518 25.7071C29.9613 25.3166 29.9613 24.6834 30.3518 24.2929L33.1559 21.4889H25.2293C24.677 21.4889 24.2293 21.0411 24.2293 20.4889Z",
    fill: "#339DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingsource);
export default __webpack_public_path__ + "static/media/fundingsource.4a39ac4b62675b0c6aefd5794d4dfee9.svg";
export { ForwardRef as ReactComponent };